import { render, staticRenderFns } from "./DesktopPaymentMethod.vue?vue&type=template&id=4bebe790&scoped=true"
import script from "./DesktopPaymentMethod.vue?vue&type=script&lang=js"
export * from "./DesktopPaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./DesktopPaymentMethod.vue?vue&type=style&index=0&id=4bebe790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bebe790",
  null
  
)

export default component.exports